<!-- third implementation  -->
<template>
  <div class="container-fluid connectionbar">
    <div class="row">
      <div class="col-md-12 px-0">
        <ConnectionBar />
      </div>
    </div>
  </div>

  <ThemeProvider>
    <!-- ✅ App always visible -->
    <router-view />
    <CommunicationFeatureModal />

    <!-- (Optional) non-blocking indicator -->
    <!--
  <div
    v-if="checkingVersion"
    class="position-fixed top-0 end-0 m-3 small text-muted"
  >
    Checking for updates…
  </div>
  -->

    <!-- ✅ Update notification -->
    <div
      v-if="updateAvailable"
      class="alert alert-primary position-fixed d-flex align-items-center justify-content-between shadow-lg"
      style="bottom: 20px; right: 20px; max-width: 350px; z-index: 9999"
    >
      <span>🚀 A new ChurchPlus update is available</span>
      <el-button
        round
        color="#0745af"
        class="text-white"
        size="small"
        @click="refreshApp"
      >
        Refresh
      </el-button>
    </div>
  </ThemeProvider>
</template>

<script>
import ConnectionBar from "@/components/connectivity/ConnectionStatus.vue";
import setupService from "./services/setup/setupservice";
import mixin from "@/mixins/currentUser.mixin.js";
import ThemeProvider from "./theme/ThemeProvider.vue";
import { GridLoader } from "vue3-spinner";
import { useVersionChecker } from "./composables/useVersionChecker";
import CommunicationFeatureModal from "@/components/communication/CommunicationFeatureModal.vue";

export default {
  name: "App",
  components: {
    ConnectionBar,
    ThemeProvider,
    GridLoader,
    CommunicationFeatureModal,
  },
  mixins: [mixin],

  setup() {
    const { updateAvailable, refreshApp, checkingVersion } =
      useVersionChecker();
    return { updateAvailable, refreshApp, checkingVersion };
  },

  created() {
    if (localStorage.getItem("token")) {
      const expiryDate = localStorage.getItem("expiryDate");
      if (expiryDate && new Date(expiryDate) < Date.now()) {
        localStorage.removeItem("token");
        localStorage.removeItem("expiryDate");
        setupService.clearStore();
      }
      // this.getCurrentUser();
      setupService.setup();
    }
  },
};
</script>

<style>
@import "./styles/style.css";
@import "./styles/styles2.css";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--el-text-color-primary);
}
.connectionbar {
  position: fixed;
  z-index: 9;
}
</style>
